export default "__VITE_ASSET__DdUH5gFu__"